
import * as api from "../constant/NewAPI";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import Utils from "../constant/Utils";
import { Button } from "react-bootstrap";
import Swal from "sweetalert2";

// import * as api from "../constant/API";

const AddInst = () => {

    const [institutionName, setInstitutionName] = useState("");
    const [group, setGroup] = useState("");
    const [type, setType] = useState("");
    const [joinDate, setJoinDate] = useState(() => {
        const today = new Date();
        return today.toISOString().split("T")[0]; // Format as 'YYYY-MM-DD'
    });
    const [address, setAddress] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [pinCode, setPinCode] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [contactName, setContactName] = useState("");
    const [contactPhone, setContactPhone] = useState("");
    const [latitude, setLatitude] = useState("");
    const [longitude, setLongitude] = useState("");
    const [userName, setUserName] = useState("");
    const [pwd, setPwd] = useState("");
    const [confirmPwd, setConfirmPwd] = useState("");
    const [groupList, setGroupList] = useState([]);
    const [typeList, setTypeList] = useState([]);
    const [error, setError] = useState("");

    const formRef = useRef(null);

    useEffect(() => {
        listGroups();
        listTypes();
    }, [])

    const formatDate = (date) => {
        const dateObj = new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    };

    function listGroups() {
        const getGroupList = api.adminGroupList;
        fetch(getGroupList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((lstResponse) => lstResponse.json())
            .then((lstResult) => {
                if (lstResult.error == true) {
                    if (lstResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    setGroupList(lstResult.data)
                }
            })
            .catch((error) => {
                console.log("Failed to fetch the group list", error);
            })
    }

    function listTypes() {
        const getTypeList = api.adminTypeList;
        fetch(getTypeList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((typLstResponse) => typLstResponse.json())
            .then((typLstResult) => {
                if (typLstResult.code == 401) {
                    Utils.logoutUser();
                }
                setTypeList(typLstResult.data)
            })
            .catch((error) => {
                console.log("Failed to fetch the type list", error);
            })
    }

    const validatePasswords = (e) => {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            formRef.current.reportValidity();
        } else {
            if (pwd && confirmPwd && pwd !== confirmPwd) {
                setError("Passwords do not match!");
            } else {
                setError("");
                saveinst();
            }
        }
    };

    function saveinst() {
        const formData = new FormData();

        formData.append("institutionName", institutionName);
        formData.append("institutionGroup", group);
        formData.append("institutionType", type);
        formData.append("institutionJoinDate", formatDate(joinDate));
        formData.append("institutionAddress", address);
        formData.append("institutionCity", city);
        formData.append("institutionState", state);
        formData.append("institutionPincode", pinCode);
        formData.append("institutionPhone", phone);
        formData.append("institutionEmail", email);
        formData.append("institutionContactName", contactName);
        formData.append("institutionContactPhone", contactPhone);
        formData.append("institutionLatitude", latitude);
        formData.append("institutionLongitude", longitude);
        formData.append("institutionUsername", userName);
        formData.append("institutionPassword", pwd);

        const saveInst = api.createInstitute;
        fetch(saveInst, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
            .catch((error) => {
                console.log("Failed to add institute", error);
            })
    }

    return (
        <>
            <div
                className="modal custom-modal fade request-modal"
                id="add-inst"
                role="dialog"
            >
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="form-header modal-header-title">
                                <h4 className="mb-0">
                                    Add Institute
                                </h4>
                            </div>
                            <Link
                                to="#"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                <span className="align-center" aria-hidden="true">
                                    <i className="feather-x" />
                                </span>
                            </Link>
                        </div>
                        <div className="modal-body">
                            <form ref={formRef}>
                                <div className="row">
                                    <div className="mb-10 col-md-4">
                                        <label className="form-label">Name</label>
                                        <input
                                            id="instName"
                                            className="form-control"
                                            style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                            value={institutionName}
                                            placeholder="Institution Name"
                                            required
                                            onChange={(e) => {
                                                setInstitutionName(e.target.value)
                                            }}
                                        />
                                    </div>

                                    <div className="mb-10 col-md-4">
                                        <label className="form-label">Group</label>
                                        <Select
                                            value={groupList.find(grp => grp.institutionGroupId === group) ? {
                                                value: group,
                                                label: groupList.find(grp => grp.institutionGroupId === group).institutionGroupName
                                            } : null}
                                            onChange={(e) => {
                                                setGroup(e.value);
                                            }}
                                            placeholder="Select Group"
                                            options={groupList.map(grp => ({
                                                value: grp.institutionGroupId,
                                                label: grp.institutionGroupName
                                            }))}>
                                        </Select>
                                    </div>

                                    <div className="mb-10 col-md-4">
                                        <label className="form-label">Type</label>
                                        <Select
                                            value={typeList.find(typ => typ.institutionTypeId === type) ? {
                                                value: type,
                                                label: typeList.find(typ => typ.institutionTypeId === type).institutionTypeName
                                            } : null}
                                            onChange={(e) => {
                                                setType(e.value);
                                            }}
                                            placeholder="Select Type"
                                            options={typeList.map(typ => ({
                                                value: typ.institutionTypeId,
                                                label: typ.institutionTypeName
                                            }))}>
                                        </Select>
                                    </div>

                                    <div className="mb-10 col-md-4">
                                        <label className="form-label">Join Date</label>
                                        <input
                                            id="joinDate"
                                            className="form-control"
                                            style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                            value={joinDate}
                                            type="date"
                                            required
                                            onChange={(e) => {
                                                setJoinDate(e.target.value)
                                            }}
                                        />
                                    </div>

                                    <div className="mb-10 col-md-8">
                                        <label className="form-label">Address</label>
                                        <input
                                            id="address"
                                            className="form-control"
                                            style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                            value={address}
                                            placeholder="Institution Address"
                                            required
                                            onChange={(e) => {
                                                setAddress(e.target.value)
                                            }}
                                        />
                                    </div>

                                    <div className="mb-10 col-md-4">
                                        <label className="form-label">City</label>
                                        <input
                                            id="instCity"
                                            className="form-control"
                                            style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                            value={city}
                                            placeholder="Institution City"
                                            required
                                            onChange={(e) => {
                                                setCity(e.target.value)
                                            }}
                                        />
                                    </div>

                                    <div className="mb-10 col-md-4">
                                        <label className="form-label">State</label>
                                        <input
                                            id="instState"
                                            className="form-control"
                                            style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                            value={state}
                                            placeholder="Institution State"
                                            required
                                            onChange={(e) => {
                                                setState(e.target.value)
                                            }}
                                        />
                                    </div>

                                    <div className="mb-10 col-md-4">
                                        <label className="form-label">Pincode</label>
                                        <input
                                            id="instPincode"
                                            className="form-control"
                                            style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                            value={pinCode}
                                            placeholder="Institution Pincode"
                                            type="number"
                                            required
                                            onChange={(e) => {
                                                setPinCode(e.target.value)
                                            }}
                                        />
                                    </div>

                                    <div className="mb-10 col-md-4">
                                        <label className="form-label">Phone</label>
                                        <input
                                            id="instPhone"
                                            className="form-control"
                                            style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                            value={phone}
                                            placeholder="Institution Phone"
                                            type="number"
                                            required
                                            onChange={(e) => {
                                                setPhone(e.target.value)
                                            }}
                                        />
                                    </div>

                                    <div className="mb-10 col-md-4">
                                        <label className="form-label">Email</label>
                                        <input
                                            id="instEmail"
                                            className="form-control"
                                            style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                            value={email}
                                            placeholder="Institution Email"
                                            type="email"
                                            required
                                            onChange={(e) => {
                                                setEmail(e.target.value)
                                            }}
                                        />
                                    </div>

                                    <div className="mb-10 col-md-4">
                                        <label className="form-label">Contact Name</label>
                                        <input
                                            id="insContacttName"
                                            className="form-control"
                                            style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                            value={contactName}
                                            placeholder="Institute Contact Name"
                                            required
                                            onChange={(e) => {
                                                setContactName(e.target.value)
                                            }}
                                        />
                                    </div>

                                    <div className="mb-10 col-md-4">
                                        <label className="form-label">Contact Phone</label>
                                        <input
                                            id="instContactPhone"
                                            className="form-control"
                                            style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                            value={contactPhone}
                                            placeholder="Institute Contact Phone"
                                            type="number"
                                            required
                                            onChange={(e) => {
                                                setContactPhone(e.target.value)
                                            }}
                                        />
                                    </div>

                                    <div className="mb-10 col-md-4">
                                        <label className="form-label">Latitude</label>
                                        <input
                                            id="instLatitude"
                                            className="form-control"
                                            style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                            value={latitude}
                                            placeholder="Institution Latitude"
                                            required
                                            onChange={(e) => {
                                                setLatitude(e.target.value)
                                            }}
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label className="form-label">Longitude</label>
                                        <input
                                            id="instLongitude"
                                            className="form-control"
                                            style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                            value={longitude}
                                            placeholder="Institution Longitude"
                                            required
                                            onChange={(e) => {
                                                setLongitude(e.target.value)
                                            }}
                                        />
                                    </div>

                                    <div className="mb-10 col-md-4">
                                        <label className="form-label">Username</label>
                                        <input
                                            id="instUserName"
                                            className="form-control"
                                            style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                            value={userName}
                                            placeholder="Institute Username"
                                            required
                                            onChange={(e) => {
                                                setUserName(e.target.value)
                                            }}
                                        />
                                    </div>

                                    <div className="mb-10 col-md-4">
                                        <label className="form-label">Password</label>
                                        <input
                                            id="instPassword"
                                            className="form-control"
                                            style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                            // value={pwd}
                                            placeholder="Password"
                                            type="password"
                                            required
                                            autoComplete="off"
                                            onChange={(e) => {
                                                setPwd(e.target.value)
                                            }}
                                        />
                                        {error && <div className="alert alert-danger">{error}</div>}
                                    </div>

                                    <div className="mb-10 col-md-4">
                                        <label className="form-label">Confirm Password</label>
                                        <input
                                            id="instConfirmPassword"
                                            className="form-control"
                                            style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                            value={confirmPwd}
                                            placeholder="Confirm Password"
                                            type="password"
                                            required
                                            onChange={(e) => {
                                                setConfirmPwd(e.target.value)
                                                // validatePasswords();
                                            }}
                                        />
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <div className="table-accept-btn">
                                <Button type="submit" className="btn btn-primary close" onClick={validatePasswords} aria-label="Close">
                                    <i className="fas fa-save" />
                                    Save
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

};

export default AddInst;